import React from 'react';
import { SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

const InstructionNotes = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        title={t('specialConsideration->>Instructions.NotesForSpecialConsiderationApplication')}
      />
      <ol>
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>Instructions.Note1Title')}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note1Content1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note1Content2')}
              </Typography>
            </li>
          </ul>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>Instructions.Note2Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>Instructions.Note3Title')}
          </Typography>
        </li>
        <br />
        <li>
          <Typography variant="body1">
            {t('specialConsideration->>Instructions.Note4Title')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content1.Part1')}
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>Instructions.Note4Content1.Part2')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('specialConsideration->>Instructions.Note4Content1.Part3')}
                  </Typography>
                </li>
              </ul>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content1.Part4')}
              </Typography>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content1.Part5')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content2.Part1')}
              </Typography>
              <br />
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content2.Part2')}
              </Typography>
              <br />
            </li>
            <li>
              <Typography variant="body1">
                {t('specialConsideration->>Instructions.Note4Content3')}
              </Typography>
            </li>
          </ol>
        </li>
        <br />
      </ol>
    </>
  );
};

export default InstructionNotes;
